import { BaseConfig } from '.'

export type Plain = 'number'

export type Config = BaseConfig & {
  type: 'number'
  defaultValue?: number
}

export type PlainResult = number
export type Result<T extends Config> = T['array'] extends true ? number[] : number

const transformValue = (value: any, config?: Config): number => {
  const defaultValue = config?.defaultValue ?? ('' as never as number)
  const parsedValue = parseFloat(value)

  return isNaN(parsedValue) ? defaultValue : parsedValue
}

export const transform = (value: any, config?: Config | Plain): number | number[] => {
  if (config === 'number') {
    return transformValue(value)
  }

  const array = config?.array ?? false

  if (array) {
    if (!Array.isArray(value)) {
      return []
    }

    return value.map((item) => transformValue(item, config))
  }

  return transformValue(value, config)
}
